// App-level config constants (Phase 5 leaf module).
export const EXT_DOT_THRESHOLD = 7;  // Oliver Kell starts scaling out at 7–10x ATR% from the 50-MA
export const VOL_COLORS = { ppv: '#3b82f6', green: '#10b981', red: '#ef4444', noise: '#334155' };
export const HUGE_RATIO = 2.0;   // a down/up day only "counts" textually if volume >= 2x the 50d average
export const TICKER_CACHE_TTL = 5 * 60 * 1000; // 5 min — re-fetch fresh after this
